import { render, staticRenderFns } from "./AnomalySchoolMismatch.vue?vue&type=template&id=3dbafa04&"
import script from "./AnomalySchoolMismatch.vue?vue&type=script&lang=js&"
export * from "./AnomalySchoolMismatch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports